import { useState } from 'react';
import { faqs } from '@/mocks/homeContent';

const trust = [
  { icon: 'ri-shield-check-line', tone: 'bg-primary-100 text-primary-800', t: '分级核实', d: '实锤 / 存疑 / 已辟谣三档状态，严格区分爆料与事实' },
  { icon: 'ri-file-search-line', tone: 'bg-accent-100 text-accent-900', t: '来源可溯', d: '事件收录均附原始出处与时间戳，多源交叉印证后才升级状态' },
  { icon: 'ri-refund-2-line', tone: 'bg-secondary-200 text-secondary-900', t: '纠错通道', d: '收到异议后 24 小时内复核，确认即补更正标签，绝不护短' },
  { icon: 'ri-user-heart-line', tone: 'bg-background-200 text-foreground-800', t: '理性倡议', d: '不造谣、不人肉、不搬运私密素材，讨论留证据再开口' },
];

export default function FaqTrust() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-900 text-background-50">
            <i className="ri-heart-2-line flex h-5 w-5 items-center justify-center" />
          </span>
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">理性吃瓜，先看这几条</h2>
            <p className="mt-1 text-sm text-foreground-600">关于核实标准与常见疑问，开聊前花一分钟了解</p>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-[360px_1fr]">
          {/* trust cards */}
          <div className="grid grid-cols-1 gap-3 content-start sm:grid-cols-2 lg:grid-cols-1">
            {trust.map((t) => (
              <div key={t.t} className="flex items-start gap-3 rounded-xl bg-background-100 p-4 ring-1 ring-background-200">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${t.tone}`}>
                  <i className={`${t.icon} flex h-5 w-5 items-center justify-center`} />
                </span>
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">{t.t}</p>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{t.d}</p>
                </div>
              </div>
            ))}
          </div>

          {/* FAQ accordion */}
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className={`overflow-hidden rounded-xl ring-1 transition ${isOpen ? 'bg-accent-50 ring-accent-200' : 'bg-background-100 ring-background-200'}`}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center gap-3 p-4 text-left md:p-5"
                  >
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-label text-sm ${isOpen ? 'bg-accent-500 text-foreground-950' : 'bg-background-200 text-foreground-600'}`}>
                      {i + 1}
                    </span>
                    <span className={`flex-1 font-heading text-base font-bold ${isOpen ? 'text-accent-900' : 'text-foreground-950'}`}>{f.q}</span>
                    <i className={`ri-arrow-down-s-line flex h-5 w-5 items-center justify-center text-foreground-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`grid transition-all ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p className="px-4 pb-4 pl-[3.9rem] pr-5 text-sm leading-6 text-foreground-600 md:px-5 md:pb-5 md:pl-[4.4rem]">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}